export const getLinks = () => [
  { name: "products", path: "/products" },
  { name: "assetManagement", path: "/asset-management" },
];
